import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AgilGanttComponent } from './agil-gantt/agil-gantt.component';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { ParamComponent } from './param/param.component';
import { OrdersFabricationListComponent } from './lightboxes/orders-fabrication-list/orders-fabrication-list.component';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  { path: 'gantt', component: AgilGanttComponent },
  { path: 'param', component: ParamComponent },
  { path: 'of-list', component: OrdersFabricationListComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
